import { Route } from '@angular/router';
import { ContainerComponent } from './core/container.component';
import { LoginComponent } from './auth/login.component';
import { JoinComponent } from './auth/join.component';
import { SchoolsComponent } from './schools/schools.component';
import { NotFoundComponent } from './core/notfound.component';
import { authGuard } from './shared/guards/auth.guard';
import { UsersComponent } from './users/users.component';
import { InvitesComponent } from './invites/invites.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { groupsResolver } from './shared/resolvers/groups.resolver';
import { GroupContainerComponent } from './group/group-container.component';
import { StudentsComponent } from './group/students/students.component';
import { FeedComponent } from './group/feed/feed.component';
import { TeachersComponent } from './group/teachers/teachers.component';
import { AdminContainerComponent } from './admin/admin-container.component';
import { GroupsComponent } from './admin/groups/groups.component';
import { SuperadminContainerComponent } from './superadmin/superadmin-container.component';
import { SessionContainerComponent } from './session/session-container.component';
import { SessionDashboardComponent } from './session/session-dashboard.compoment';
import { SessionParticipateComponent } from './session/session-participate';
import { sessionResolver } from './shared/resolvers/session.resolver';
import { ForgottenPasswordComponent } from './auth/forgotten-password.component';
import { ResetPasswordComponent } from './auth/reset-password.component';
import { groupResolver } from './shared/resolvers/group.resolver';
import { LockedComponent } from './core/locked.component';
import { pinGuard } from './shared/guards/pin.guard';
import { StudentComponent } from './group/students/student.component';
import { studentResolver } from './shared/resolvers/student.resolver';

export const appRoutes: Route[] = [
  { path: 'login', component: LoginComponent },
  { path: 'join', component: JoinComponent },
  { path: 'forgotten-password', component: ForgottenPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: '',
    component: ContainerComponent,
    canActivate: [authGuard, pinGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent, resolve: { groups: groupsResolver } },
      { path: 'schools', component: SchoolsComponent },
      { path: 'invites', component: InvitesComponent },
      { path: 'users', component: UsersComponent },
      { path: 'group/:id', redirectTo: 'group/:id/feed', pathMatch: 'full' },
      {
        path: 'group/:id',
        component: GroupContainerComponent,
        resolve: { groups: groupsResolver, group: groupResolver },
        children: [
          { path: 'feed', component: FeedComponent },
          { path: 'users', component: TeachersComponent },
          { path: 'students', component: StudentsComponent },
          { path: 'students/:id', component: StudentComponent, resolve: { student: studentResolver } },
        ],
      },
      { path: 'admin', redirectTo: 'admin/groups', pathMatch: 'full' },
      {
        path: 'admin',
        component: AdminContainerComponent,
        children: [
          { path: 'groups', component: GroupsComponent },
          { path: 'users', component: UsersComponent, data: { scopeToSchool: true } },
          { path: 'invites', component: InvitesComponent, data: { scopeToSchool: true } },
        ],
      },
      { path: 'superadmin', redirectTo: 'superadmin/schools', pathMatch: 'full' },
      {
        path: 'superadmin',
        component: SuperadminContainerComponent,
        children: [
          { path: 'schools', component: SchoolsComponent },
          { path: 'users', component: UsersComponent },
          { path: 'invites', component: InvitesComponent },
        ],
      },
    ],
  },
  { path: 'session/:id', redirectTo: 'session/:id/dashboard', pathMatch: 'full' },
  {
    path: 'session/:id',
    component: SessionContainerComponent,
    resolve: { session: sessionResolver },
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: SessionDashboardComponent },
      { path: 'participate/:info', component: SessionParticipateComponent },
    ],
  },
  { path: 'locked', component: LockedComponent },
  { path: '**', component: NotFoundComponent },
];
